import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import {
  Button,
  Checkbox,
  Icon,
  Input,
  Pagination,
  Popconfirm,
  Popover,
  Select,
  Switch,
  Table,
  Tooltip,
  TreeSelect,
  notification,
} from "antd"
import images from "themes/images"
import ContiGiocoModal from "../../shared-components/adminSharedComp/adminModals/ContiGiocoModal/ContiGiocoModal"
import { withRouter } from "react-router"
import AddServiceModalForm from "../../shared-components/adminSharedComp/adminModals/AddServiceModal/AddServiceModal"
import { useParams } from "react-router-dom"
import { baseUrlImg } from "../../config/api"
import AddListinoModalForm from "../domains/adminPanel/Listino/AddListinoModal"

const { Option } = Select

export function useDebounce(value, delay = 1000) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => clearTimeout(handler)
  }, [value, delay])

  return debouncedValue
}

const NewServicesAdmin = (props) => {
  const {
    activeSkinId,
    screenWidth,
    MessaggiComponent,
    getAllServices,
    allServices,
    getSelectedCompany,
    getContiAccount,
    setContiAccount,
    setNewContiStatus,
    UpdateServicesChangeStatus,
    changeServiceCategory,
    setActiveSkinId,
    setActiveSkinName,
    skinList,
    history,
    getContiGiocoServices,
    updateServiceName,
    getProviders,
    accountInfo,
    providers,
    getServicesTree,
    servicesTree,
    setSelectedCompany,
    updateCompany,
    getListinoList,
    listinoList,
    createListino,
    contiGiocoServices,
  } = props

  const { provider, id, listino } = useParams()

  const [selectedSupplier, setSelectedSupplier] = useState(provider || "TUTTI")
  const [filterName, setFilterName] = useState("")
  const debouncedFilterName = useDebounce(filterName, 500)

  const [activeCategory, setActiveCategory] = useState(id || "TUTTI")

  const [openModal, setOpenModal] = useState(false)
  const [service, setService] = useState("")
  const [isEditing, setIsEditing] = useState(false)
  const [editedName, setEditedName] = useState("")
  const [loading, setLoading] = useState(false)
  const [focusedRow, setFocusedRow] = useState(null)
  const [blurRow, setBlurRow] = useState(null)
  const [addServiceModalVisible, setAddServiceModalVisible] = useState(false)
  const [addListinoModalVisible, setAddListinoModalVisible] = useState(false)

  const [isEditingAgenzia, setIsEditingAgenzia] = useState(false)
  const [focusedRowAgenzia, setFocusedRowAgenzia] = useState(null)
  const [editedValueAgenzia, setEditedValueAgenzia] = useState(null)
  const [agenziaLoading, setAgenziaLoading] = useState(false)

  const [isEditingAggioNet, setIsEditingAggioNet] = useState(false)
  const [editedValueAggioNet, setEditedValueAggioNet] = useState(null)
  const [focusedRowAggioNet, setFocusedRowAggioNet] = useState(null)
  const [aggioNetLoading, setAggioNetLoading] = useState(false)
  const [sort, setSort] = useState(null)
  const [filter, setFilter] = useState(null)

  const [selectedListino, setSelectedListino] = useState(1)
  const [visibleColumns, setVisibleColumns] = useState({
    "Nome Servizio": true,
    Category: true,
    Impostazioni: true,
    Images: {
      Icon: false,
      Logo: false,
      Scontrino: false,
      Background: false,
    },
    Proviggione: {
      Agenzia: true,
      "Aggio Skin": true,
      "Aggio Bruto": true,
    },
    Company: true,
  })

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [perPage, setPerPage] = useState(25)
  useEffect(() => {
    if (listino) {
      const parsedListino = Number(listino)
      if (!isNaN(parsedListino)) {
        setSelectedListino(parsedListino)
      }
    } else if (listinoList?.length) {
      setSelectedListino(listinoList[0].id)
    }
  }, [listino, listinoList])

  useEffect(() => {
    if (skinList?.length > 0 && selectedListino) {
      const firstSkin = skinList[0]
      if (activeSkinId === -1) {
        setActiveSkinId(firstSkin.id)
        setActiveSkinName(firstSkin.username)
        setActiveCategory(id !== undefined ? id : "TUTTI")
        getAllServices(
          firstSkin.id,
          selectedSupplier !== "TUTTI" ? selectedSupplier : null,
          selectedListino,
          currentPage,
          perPage,
          filterName,
          id !== undefined ? id : "TUTTI",
          sort,
          filter,
        )
      } else {
        getAllServices(
          activeSkinId,
          selectedSupplier !== "TUTTI" ? selectedSupplier : null,
          selectedListino,
          currentPage,
          perPage,
          filterName,
          id !== undefined ? id : "TUTTI",
          sort,
          filter,
        )
      }
    }
  }, [activeSkinId, skinList, selectedListino, currentPage, activeCategory])

  useEffect(() => {
    const currentUrl = window.origin + window.location.hash

    if (!provider) {
      if (!selectedListino) {
        window.location.href = `${currentUrl}/${selectedSupplier}/${activeCategory}/${listinoList[0]?.id}`
      } else {
        window.location.href = `${currentUrl}/${selectedSupplier}/${activeCategory}/${selectedListino}`
      }
    } else if (provider && !id) {
      window.location.href = `${currentUrl}/${activeCategory}`
    }
  }, [provider, selectedSupplier, id, listinoList])

  useEffect(() => {
    getContiGiocoServices()
    getServicesTree()
    getProviders()
    getListinoList()
  }, [])

  useEffect(() => {
    if (activeSkinId === -1) return
    if (!selectedListino) return

    setCurrentPage(1)

    getAllServices(
      activeSkinId,
      selectedSupplier !== "TUTTI" ? selectedSupplier : null,
      selectedListino,
      1,
      perPage,
      debouncedFilterName,
      activeCategory,
      sort,
      filter,
    )
  }, [debouncedFilterName, activeSkinId, selectedSupplier, selectedListino, perPage])

  const handleUpdateServiceName = (id) => {
    updateServiceName(id, editedName, setLoading)
    setEditedName("")
  }

  const handleCheckboxChange = (e, colKey, subKey) => {
    const updatedColumns = { ...visibleColumns }

    if (subKey) {
      updatedColumns[colKey][subKey] = e.target.checked
    } else {
      updatedColumns[colKey] = e.target.checked
    }

    // localStorage.setItem("visibleColumns", JSON.stringify(updatedColumns))
    setVisibleColumns(updatedColumns)
  }

  const handleCheckAll = (colKey) => {
    const updatedColumns = { ...visibleColumns }
    const allChecked = Object.values(updatedColumns[colKey]).every(Boolean)
    const newState = allChecked ? false : true
    Object.keys(updatedColumns[colKey]).forEach((subKey) => {
      updatedColumns[colKey][subKey] = newState
    })

    // localStorage.setItem("visibleColumns", JSON.stringify(updatedColumns))
    setVisibleColumns(updatedColumns)
  }

  const handleSettingsClick = async (record) => {
    if (record.category === "Visure") {
      window.location.href = `${window.origin + window.location.hash}/${record.id}`
    } else {
      await getSelectedCompany(record.id, selectedListino)
      window.location.href = `${window.origin + window.location.hash}/edit/${
        record.id
      }`
    }
  }

  const transformToTreeData = (categories) => {
    return categories
      .filter((category) => category.full_name !== "Uncategorized")
      .map((category) => ({
        title: category.full_name ?? category.name,
        value: category.id.toString(),
        children: transformToTreeData(category.children_recursive),
      }))
  }

  const columns =
    screenWidth < 500
      ? [
          {
            title: "Nome servizio",
            dataIndex: "full_name",
            key: "full_name",
            ellipsis: true,
            width: "25%",
          },
          {
            title: "Provvigione",
            dataIndex: "provvigione",
            key: "provvigione",
            ellipsis: true,
            align: "right",
            width: "50%",
            render: (text) => `${text}€`,
          },
          {
            title: "Impostazioni",
            dataIndex: "impostazioni",
            key: "impostazioni",
            width: "25%",
            ellipsis: true,
            align: "center",
            render: (text, record) => (
              <div className="icons">
                <i
                  className="fal fa-cog"
                  onClick={() => handleSettingsClick(record)}
                />
              </div>
            ),
          },
        ]
      : [
          {
            title: "ID",
            dataIndex: "company_id",
            key: "company_id",
            ellipsis: true,
            width: "6%",
          },

          visibleColumns["Nome Servizio"] && {
            title: () => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  width: "100%",
                }}
              >
                <span>Nome servizio</span>
                <i
                  className="fa-regular fa-pen-to-square"
                  style={{ position: "absolute", right: "0px", cursor: "pointer" }}
                  onClick={() => setIsEditing(!isEditing)}
                ></i>
              </div>
            ),
            dataIndex: "full_name",
            key: "full_name",
            ellipsis: true,
            width: "12%",
            sorter: true, // just set true, actual sorting handled via onChange
            render: (text, record) =>
              isEditing ? (
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Input
                    defaultValue={text}
                    onChange={(e) => setEditedName(e.target.value)}
                    style={{ width: "100%", paddingRight: 20 }}
                    onFocus={() => {
                      setFocusedRow(record.id)
                      if (focusedRow === blurRow && editedName) {
                        updateServiceName(blurRow, editedName)
                        setEditedName("")
                      }
                    }}
                    onBlur={() => setBlurRow(record.id)}
                  />
                  {focusedRow === record.id && (
                    <Icon
                      type={loading ? "loading" : "save"}
                      className="save-icon"
                      style={{
                        fontSize: 18,
                        position: "absolute",
                        right: "10px",
                        cursor: "pointer",
                        color: "#0078ff",
                      }}
                      onClick={() => handleUpdateServiceName(record.id)}
                    />
                  )}
                </div>
              ) : (
                <div>{text}</div>
              ),
          },

          selectedSupplier === "Exalogic" && {
            title: "Wallet",
            dataIndex: "wallet",
            key: "wallet",
            ellipsis: true,
            width: "8%",
            render: (text, record) => {
              const matchingWallet = contiGiocoServices?.find(
                (cg) => cg.company_id === record.id,
              )?.wallet

              const formattedWallet = matchingWallet
                ? `${parseFloat(matchingWallet).toFixed(2)}€`
                : "N/A"

              return formattedWallet
            },
          },

          selectedSupplier === "TUTTI" && {
            title: "Provider",
            dataIndex: "provider",
            key: "provider",
            ellipsis: true,
            align: "center",
            width: "6%",
            render: (text, record) => {
              const exactIcon = `${baseUrlImg}/icon/${record?.provider_name}-icon.svg`
              const lowerIcon = `${baseUrlImg}/icon/${record?.provider_name?.toLowerCase()}-icon.svg`
              return (
                <Tooltip title={record.provider}>
                  <div style={{ padding: 0 }}>
                    <img
                      src={exactIcon}
                      style={{
                        width: "28px",
                        height: "28px",
                        padding: 0,
                        marginRight: "5px",
                      }}
                      onError={(e) => {
                        const img = e.currentTarget
                        if (img.src !== lowerIcon) {
                          img.src = lowerIcon
                        } else {
                          img.src = `${baseUrlImg}/icon/default-icon.svg`
                        }
                      }}
                    />
                  </div>
                </Tooltip>
              )
            },
          },

          visibleColumns.Category && {
            title: "Category",
            dataIndex: "category",
            key: "category",
            ellipsis: true,
            width: "15%",
            sorter: (a, b) => {
              const categoryA = a?.category || ""
              const categoryB = b?.category || ""
              return categoryA.localeCompare(categoryB)
            },

            render: (text, record) => (
              <TreeSelect
                showSearch
                style={{ width: "100%" }}
                value={record.category}
                dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                onChange={(value) => {
                  changeServiceCategory(record.id, value)
                  getAllServices(
                    activeSkinId,
                    selectedSupplier !== "TUTTI" ? selectedSupplier : null,
                    selectedListino,
                    currentPage,
                    perPage,
                    filterName,
                    activeCategory,
                    sort,
                    filter,
                  )
                }}
                treeData={[
                  {
                    title: "Uncategorized",
                    value: 47,
                    key: "uncategorized",
                  },
                  ...transformToTreeData(servicesTree),
                ]}
                filterTreeNode={(inputValue, treeNode) =>
                  treeNode.props.title
                    .toLowerCase()
                    .includes(inputValue.toLowerCase())
                }
              />

              // <Select
              //   defaultValue={record.category}
              //   onChange={(value) => {
              //     changeServiceCategory(record.id, value)
              //   }}
              //   style={{ width: "100%" }}
              // >
              //   {allServices?.categories?.map((c) => (
              //     <Option
              //       value={c.id}
              //       key={c.id}
              //       style={{
              //         textTransform: "none",
              //       }}
              //     >
              //       {c.name}
              //     </Option>
              //   ))}
              // </Select>
            ),
          },

          visibleColumns?.Images?.Icon && {
            title: "Icona",
            dataIndex: "icon",
            key: "icon",
            ellipsis: true,
            width: screenWidth < 1490 ? "8%" : "12%",
            render: (text, record) => (
              <>
                <img
                  onClick={() => handleSettingsClick(record)}
                  src={
                    record.icon
                      ? `${baseUrlImg}/${record.icon}`
                      : images["placeholder"]
                  }
                  alt="icon"
                  width={30}
                  height={30}
                  style={{ objectFit: "contain", marginRight: 10 }}
                />

                <a
                  href={`${baseUrlImg}/${record.icon}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="image-link"
                >
                  {text?.split("/").pop()}
                </a>
              </>
            ),
          },
          visibleColumns?.Images?.Logo && {
            title: "Logo",
            dataIndex: "logo",
            key: "logo",
            ellipsis: true,
            width: screenWidth < 1490 ? "8%" : "12%",
            render: (text, record) => (
              <>
                <img
                  onClick={() => handleSettingsClick(record)}
                  src={
                    // selectedSupplier === "E-Pay"
                    //   ?
                    record.logo
                      ? `${baseUrlImg}/${record.logo}`
                      : images["placeholder"]
                    // : images[record.name]
                  }
                  alt="logo"
                  width={30}
                  height={30}
                  style={{ objectFit: "contain", marginRight: 10 }}
                />
                <a
                  href={`${baseUrlImg}/${record.logo}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="image-link"
                >
                  {text?.split("/").pop()}
                </a>
              </>
            ),
          },
          visibleColumns?.Images?.Scontrino && {
            title: "Logo scontrino",
            dataIndex: "scontrino",
            key: "scontrino",
            ellipsis: true,
            width: screenWidth < 1490 ? "8%" : "12%",
            render: (text, record) => (
              <>
                <img
                  onClick={() => handleSettingsClick(record)}
                  src={
                    record.scontrino
                      ? `${baseUrlImg}/${record.scontrino}`
                      : images["placeholder"]
                  }
                  alt="logo"
                  width={30}
                  height={30}
                  style={{ objectFit: "contain", marginRight: 10 }}
                />
                <a
                  href={`${baseUrlImg}/${record.scontrino}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="image-link"
                >
                  {text?.split("/").pop()}
                </a>
              </>
            ),
          },
          visibleColumns?.Images?.Background && {
            title: "Background",
            dataIndex: "background",
            key: "background",
            width: screenWidth < 1490 ? "8%" : "12%",
            ellipsis: true,
            render: (text, record) => (
              <>
                <img
                  onClick={() => handleSettingsClick(record)}
                  src={
                    record.background
                      ? `${baseUrlImg}/${record.background}`
                      : images["placeholder"]
                  }
                  alt="logo"
                  width={30}
                  height={30}
                  style={{ objectFit: "contain", marginRight: 10 }}
                />
                <a
                  href={`${baseUrlImg}/${record.background}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="image-link"
                >
                  {text?.split("/").pop()}
                </a>
              </>
            ),
          },

          // visibleColumns.Provvigione && {
          //   title: "Provvigione",
          //   dataIndex: "provvigione",
          //   key: "provvigione",
          //   ellipsis: true,
          //   align: "left",
          //   width: "14%",
          //   render: (text) => `${text.join(", ")}`,
          // },
          visibleColumns?.Proviggione.Agenzia && {
            dataIndex: "provvigione",
            key: "agenzia",
            ellipsis: true,
            width: "10%",
            title: () => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    width: "100%",
                    marginLeft: -4,
                  }}
                >
                  <span>Agenzia</span>
                  <i
                    className="fa-regular fa-pen-to-square"
                    style={{ position: "absolute", right: "0px", cursor: "pointer" }}
                    onClick={() => setIsEditingAgenzia(!isEditingAgenzia)}
                  ></i>
                </div>
              )
            },
            sorter: (a, b) => {
              const aValue = parseFloat(a?.provvigione?.[0] || "0")
              const bValue = parseFloat(b?.provvigione?.[0] || "0")
              return aValue - bValue
            },

            render: (text, record) => {
              if (!text || (Array.isArray(text) && text.length === 0)) {
                return "-"
              }

              const values = Array.isArray(text) ? text : text.split(",")
              const trimmedValues = values.map((val) => val?.trim()).filter(Boolean)

              if (trimmedValues.length === 0) {
                return "-"
              }

              const allSame = trimmedValues.every((val) => val === trimmedValues[0])
              const defaultValue = allSame
                ? `${parseFloat(trimmedValues[0]).toFixed(2)}%`
                : trimmedValues
                    .map((val) => `${parseFloat(val).toFixed(2)}%`)
                    .join(", ")

              if (isEditingAgenzia && allSame) {
                return (
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Input
                      defaultValue={defaultValue}
                      onChange={(e) => setEditedValueAgenzia(e.target.value)}
                      style={{ width: "100%" }}
                      onFocus={() => {
                        setFocusedRowAgenzia(record.id)
                        setEditedValueAgenzia(null)
                      }}
                    />
                    {focusedRowAgenzia === record.id && (
                      <Icon
                        type={agenziaLoading ? "loading" : "save"}
                        className="save-icon"
                        style={{
                          fontSize: 18,
                          position: "absolute",
                          right: "10px",
                          cursor: "pointer",
                          color: "#0078ff",
                        }}
                        onClick={() => {
                          let value = editedValueAgenzia
                            ? editedValueAgenzia
                            : defaultValue
                          value = value.replace("%", "").trim()
                          console.log(record.id, value)

                          updateCompany(
                            record.id,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            { default: { provigione: value } },
                            null,
                            null,
                            true,
                            null,
                            setAgenziaLoading,
                            listino,
                          )
                        }}
                      />
                    )}
                  </div>
                )
              }

              if (allSame) {
                return `${parseFloat(trimmedValues[0]).toFixed(2)}%`
              } else {
                const displayText = `${trimmedValues[0]}%,...`
                const fullText = trimmedValues
                  .map((val) => `${parseFloat(val).toFixed(2)}%`)
                  .join(", ")

                return (
                  <Tooltip title={fullText}>
                    <span className="cursor-help underline decoration-dotted">
                      {displayText}
                    </span>
                  </Tooltip>
                )
              }
            },
          },

          visibleColumns?.Proviggione["Aggio Skin"] && {
            title: "Aggio Skin",
            dataIndex: "skin_percentage",
            key: "skin",
            ellipsis: true,
            width: "10%",
            render: (text) => {
              return `${text}%`
            },
          },

          visibleColumns?.Proviggione["Aggio Bruto"] && {
            title: () => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    width: "100%",
                    marginLeft: -4,
                  }}
                >
                  <span>Aggio Bruto</span>
                  <i
                    className="fa-regular fa-pen-to-square"
                    style={{ position: "absolute", right: "0px", cursor: "pointer" }}
                    onClick={() => setIsEditingAggioNet(!isEditingAggioNet)}
                  ></i>
                </div>
              )
            },
            dataIndex: "aggio_net",
            key: "aggio_net",
            ellipsis: true,
            width: "10%",
            sorter: (a, b) => {
              const aValue = parseFloat(
                Array.isArray(a?.aggio_net) ? a.aggio_net[0] : "0",
              )
              const bValue = parseFloat(
                Array.isArray(b?.aggio_net) ? b.aggio_net[0] : "0",
              )
              return aValue - bValue
            },
            render: (text, record) => {
              if (!text || (Array.isArray(text) && text.length === 0)) {
                return "-"
              }

              const values = Array.isArray(text) ? text : text.split(",")
              const trimmedValues = values.map((val) => val?.trim()).filter(Boolean)

              if (trimmedValues.length === 0) {
                return "-"
              }

              const allSame = trimmedValues.every((val) => val === trimmedValues[0])
              const defaultValue = allSame
                ? `${parseFloat(trimmedValues[0]).toFixed(2)}%`
                : trimmedValues
                    .map((val) => `${parseFloat(val).toFixed(2)}%`)
                    .join(", ")

              if (isEditingAggioNet && allSame) {
                return (
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Input
                      defaultValue={defaultValue}
                      onChange={(e) => setEditedValueAggioNet(e.target.value)}
                      style={{ width: "100%" }}
                      onFocus={() => {
                        setFocusedRowAggioNet(record.id)
                        setEditedValueAggioNet(null)
                      }}
                    />
                    {focusedRowAggioNet === record.id && (
                      <Icon
                        type={aggioNetLoading ? "loading" : "save"}
                        className="save-icon"
                        style={{
                          fontSize: 18,
                          position: "absolute",
                          right: "10px",
                          cursor: "pointer",
                          color: "#0078ff",
                        }}
                        onClick={() => {
                          let value = editedValueAggioNet
                            ? editedValueAggioNet
                            : defaultValue
                          value = value.replace("%", "").trim()
                          console.log(record.id, value)

                          updateCompany(
                            record.id,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            { default: { system_aggio: value } },
                            null,
                            null,
                            true,
                            null,
                            setAggioNetLoading,
                            listino,
                          )
                        }}
                      />
                    )}
                  </div>
                )
              }

              if (allSame) {
                return `${parseFloat(trimmedValues[0]).toFixed(2)}%`
              } else {
                const displayText = `${trimmedValues[0]}%,...`
                const fullText = trimmedValues
                  .map((val) => `${parseFloat(val).toFixed(2)}%`)
                  .join(", ")

                return (
                  <Tooltip title={fullText}>
                    <span className="cursor-help underline decoration-dotted">
                      {displayText}
                    </span>
                  </Tooltip>
                )
              }
            },
          },

          visibleColumns.Company && {
            title: "Company",
            dataIndex: "serviceActive",
            key: "serviceActive",
            width: "8%",
            ellipsis: true,
            align: "center",
            filters: [
              { text: "Active", value: 1 },
              { text: "Blocked", value: 0 },
            ],
            render: (text, record) => {
              const isActive = record.active === 1
              const nextState = !isActive

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    justifyContent: "center",
                  }}
                >
                  <Popconfirm
                    title={`Stai per ${nextState ? "attivare" : "disattivare"} il servizio ${record.name}`}
                    okText="Approva"
                    cancelText="Annulla"
                    okButtonProps={{
                      danger: !nextState,
                    }}
                    onConfirm={async () => {
                      await UpdateServicesChangeStatus(
                        record.name,
                        record.full_name,
                        record.id,
                        nextState,
                        activeSkinId,
                        async () => {
                          await getAllServices(
                            activeSkinId,
                            selectedSupplier !== "TUTTI" ? selectedSupplier : null,
                            selectedListino,
                            currentPage,
                            perPage,
                            filterName,
                            activeCategory,
                            sort,
                            filter,
                          )
                        },
                        null,
                        false,
                      )
                    }}
                  >
                    <Button
                      type={isActive ? "primary" : "default"}
                      danger={!isActive}
                      size="small"
                      className="company-activation-btn"
                      style={{
                        backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
                        borderColor: isActive ? "#52c41a" : "#ff4d4f",
                        color: "#fff",
                        fontWeight: 500,
                        fontSize: 12,
                        borderRadius: 4,
                        minWidth: 60,
                        padding: "0 8px",
                      }}
                    >
                      {isActive ? "Active" : "Blocked"}
                    </Button>
                  </Popconfirm>
                </div>
              )
            },
          },
          visibleColumns.Impostazioni && {
            title: "Impostazioni",
            dataIndex: "impostazioni",
            key: "impostazioni",
            width: "8%",
            ellipsis: true,

            render: (text, record) => {
              return (
                <div className="icons">
                  {/* <Switch
                    style={{ width: 30, marginRight: 5 }}
                    size="small"
                    checked={record.active === 1}
                    // checkedChildren="Attivo"
                    // unCheckedChildren="Inattivo"
                    onChange={async (checked) => {
                      if (checked) {
                        if (record.active === 0) {
                          await UpdateServicesChangeStatus(
                            record.name,
                            record.full_name,
                            record.id,
                            true,
                            activeSkinId,
                            async () => {
                              await getAllServices(
                                activeSkinId,
                                selectedSupplier !== "TUTTI"
                                  ? selectedSupplier
                                  : null,
                                selectedListino,
                                false
                              )
                            }
                          )
                        } else {
                          notification["success"]({
                            message: "Lo stato è già attivato",
                          })
                        }
                      } else {
                        if (record.active === 1) {
                          await UpdateServicesChangeStatus(
                            record.name,
                            record.full_name,
                            record.id,
                            false,
                            activeSkinId,
                            async () => {
                              await getAllServices(
                                activeSkinId,
                                selectedSupplier !== "TUTTI"
                                  ? selectedSupplier
                                  : null,
                                selectedListino,
                                false
                              )
                            }
                          )
                        } else {
                          notification["error"]({
                            message: "Lo stato è già disattivato",
                          })
                        }
                      }
                    }}
                  /> */}

                  <Switch
                    style={{ width: 30, marginRight: 5 }}
                    size="small"
                    checked={record.serviceActive === 1}
                    onChange={async (checked) => {
                      const isActive = record.serviceActive === 1

                      if (checked) {
                        if (!isActive) {
                          await UpdateServicesChangeStatus(
                            record.name,
                            record.full_name,
                            record.id,
                            true,
                            activeSkinId,
                            async () => {
                              await getAllServices(
                                activeSkinId,
                                selectedSupplier !== "TUTTI"
                                  ? selectedSupplier
                                  : null,
                                selectedListino,
                                currentPage,
                                perPage,
                                filterName,
                                activeCategory,
                                sort,
                                filter,
                              )
                            },
                            Number(listino),
                            true,
                          )
                        } else {
                          notification["info"]({
                            message: "Lo stato è già attivato",
                          })
                        }
                      } else {
                        if (isActive) {
                          await UpdateServicesChangeStatus(
                            record.name,
                            record.full_name,
                            record.id,
                            false,
                            activeSkinId,
                            async () => {
                              await getAllServices(
                                activeSkinId,
                                selectedSupplier !== "TUTTI"
                                  ? selectedSupplier
                                  : null,
                                selectedListino,
                                currentPage,
                                perPage,
                                filterName,
                                activeCategory,
                                sort,
                                filter,
                              )
                            },
                            Number(listino),
                            true,
                          )
                        } else {
                          notification["info"]({
                            message: "Lo stato è già disattivato",
                          })
                        }
                      }
                    }}
                  />
                  <i
                    className="fal fa-cog"
                    onClick={() => handleSettingsClick(record)}
                  />

                  {record.service_type === "exalogic" && (
                    <i
                      className="fal fa-user"
                      onClick={async () => {
                        await getSelectedCompany(record.id, selectedListino)
                        await getContiAccount(record.service_id)
                        setOpenModal(true)
                        setService(record)
                      }}
                    />
                  )}
                </div>
              )
            },
          },
          // visibleColumns.Adyen && {
          //   title: "Adyen",
          //   dataIndex: "adyen",
          //   key: "adyen",
          //   width: "5%",
          //   ellipsis: true,
          //   align: "center",
          //   render: (text, record) => (
          //     <Checkbox
          //       checked={text}
          //       onClick={() => {
          //       allowPayWithAdyen(record.company_id)

          //       }}
          //     />
          //   ),
          // },
        ].filter(Boolean)

  const data =
    allServices &&
    allServices?.data?.map((s) => ({
      id: s.number_id,
      full_name: s.full_name ?? s.name,
      name: s.name,
      category: s.category_full_name ?? s.category,
      icon: s.icon,
      logo: s.logo,
      scontrino: s.scontrino,
      background: s.background,
      provvigione: s.services_agency_guadagno,
      aggio_net: s.services_system_aggio,
      skin_percentage: s.skin_percentage,
      service_type: s.service_type,
      service_id: s.service_id,
      active: s.active,
      category_id: s.category_id,
      company_id: s.number_id,
      provider_name: s.provider_name,
      serviceActive: s.serviceActive,
    }))

  // //VISURE EDIT

  // const filterVisureServicesByCompanyId = (companyId) =>
  //   (allServices?.companies || []).filter(
  //     ({ number_id }) => number_id === Number(companyId)
  //   )

  // if (!isNaN(id)) {
  //   return (
  //     <AdminSubServizzi
  //       services={filterVisureServicesByCompanyId(id)}
  //       serviceSelected={id}
  //     />
  //   )
  // }

  return (
    <>
      <AddListinoModalForm
        isVisible={addListinoModalVisible}
        onClose={() => setAddListinoModalVisible(false)}
        createListino={createListino}
        listinoList={listinoList}
      />

      <ContiGiocoModal
        open={openModal}
        onClose={() => {
          setSelectedCompany(null)
          setOpenModal(false)
          setContiAccount(null)
          setNewContiStatus(null)
        }}
        service={service}
      />
      <AddServiceModalForm
        isVisible={addServiceModalVisible}
        onClose={() => setAddServiceModalVisible(false)}
        accountInfo={accountInfo}
        providers={providers}
      />
      <div
        className="Container Annunci AllTransazioni AllServices"
        style={{ paddingBottom: screenWidth < 500 && "100px", width: "100%" }}
      >
        {MessaggiComponent}
        <div
          className="container-fluid overview"
          style={{
            paddingBottom: 50,
          }}
        >
          <div className="panels-container">
            <div className="sort-annunci adminAnnunci ">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: 4,
                }}
              >
                <div className="filters">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "171px",
                    }}
                  >
                    <h1
                      className="headerTop "
                      onClick={() => {
                        setFilterName("")
                        setCurrentPage(1)
                      }}
                    >
                      <Icon type="shop" />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: 22,
                        }}
                      >
                        <span>Servizi</span>
                        <span style={{ marginLeft: 4 }}>
                          ({allServices.total ?? "0"})
                        </span>
                      </div>
                    </h1>

                    {screenWidth < 500 && (
                      <Input
                        className="search-service"
                        placeholder="Cerca Servizi "
                        type="text"
                        suffix={<Icon type="search" />}
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                      />
                    )}
                  </div>

                  <div style={{ display: "flex" }}>
                    <Select
                      defaultValue={selectedSupplier}
                      onChange={(value) => {
                        setSelectedSupplier(value)
                        getAllServices(
                          activeSkinId,
                          value !== "TUTTI" ? value : null,
                          selectedListino,
                          1,
                          perPage,
                          filterName,
                          activeCategory,
                          sort,
                          filter,
                        )
                        history.push(
                          `/back-office/servizi/${value}/${activeCategory}/${selectedListino}`,
                        )
                      }}
                    >
                      <Option value="TUTTI">TUTTI</Option>

                      {providers &&
                        providers.map((provider) => {
                          const exactIcon = `${baseUrlImg}/icon/${provider.name}-icon.svg`
                          const lowerIcon = `${baseUrlImg}/icon/${provider.name.toLowerCase()}-icon.svg`

                          return (
                            <Option value={provider.name} key={provider.name}>
                              <img
                                width={30}
                                height={30}
                                src={exactIcon}
                                alt={provider.name}
                                onError={(e) => {
                                  const img = e.currentTarget

                                  if (!img.dataset.fallbackAttempted) {
                                    img.dataset.fallbackAttempted = "true"
                                    img.src = lowerIcon
                                  }
                                }}
                                style={{ marginRight: "10px" }}
                              />
                              {provider.name}
                            </Option>
                          )
                        })}
                    </Select>
                    <TreeSelect
                      showSearch
                      style={{ width: "100%" }}
                      value={activeCategory}
                      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                      placeholder="Seleziona una categoria"
                      allowClear
                      onChange={(value) => {
                        setCurrentPage(1)
                        setActiveCategory(value)
                        history.push(
                          `/back-office/servizi/${selectedSupplier}/${value}/${selectedListino}`,
                        )
                      }}
                      treeData={[
                        { title: "TUTTI", value: "TUTTI", key: "TUTTI" },
                        {
                          title: "Uncategorized",
                          value: 47,
                          key: "uncategorized",
                        },
                        ...transformToTreeData(servicesTree),
                      ]}
                      filterTreeNode={(inputValue, treeNode) => {
                        return treeNode.props.title
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }}
                    />
                    {/* <Select
                    defaultValue={activeCategory}
                    onChange={(value) => {
                      console.log(value)
                      setActiveCategory(value)
                    }}
                  >
                    <Option value="TUTTI">TUTTI</Option>
                    {allServices?.categories?.map((c) => (
                      <Option value={c.id} key={c.id}>
                        {c.name}
                      </Option>
                    ))}
                  </Select> */}

                    {screenWidth > 500 && (
                      <Input
                        className="search-service"
                        placeholder="Cerca Servizi "
                        type="text"
                        suffix={<Icon type="search" />}
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                      />
                    )}

                    <Button
                      icon="plus"
                      type="primary"
                      className="add-service-btn"
                      // onClick={() => history.push("/back-office/add-product")}
                      onClick={() => setAddServiceModalVisible(true)}
                    >
                      Aggiungi Servizio
                    </Button>
                    {/* <Button
                      icon="plus"
                      type="primary"
                      className="add-service-btn"
                      onClick={() => setAddListinoModalVisible(true)}
                    >
                      Crea Nuovo Listino
                    </Button> */}
                    <Select
                      value={selectedListino}
                      onChange={(e) => {
                        setDropdownOpen(false)
                        setSelectedListino(e)
                        history.push(
                          `/back-office/servizi/${selectedSupplier}/${activeCategory}/${e}`,
                        )
                      }}
                      open={dropdownOpen}
                      onDropdownVisibleChange={(visible) => setDropdownOpen(visible)}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <div className="p-2">
                            <Button
                              style={{ width: "100%" }}
                              icon="plus"
                              type="primary"
                              className="add-service-btn "
                              onMouseDown={(e) => e.stopPropagation()}
                              onClick={() => {
                                setAddListinoModalVisible(true)
                                console.log("click")
                                setDropdownOpen(true)
                              }}
                            >
                              Aggiungi Listino
                            </Button>
                          </div>
                        </>
                      )}
                    >
                      {listinoList &&
                        listinoList
                          .filter((l) => l.status === 1)
                          .map((listino) => (
                            <Option key={listino.id} value={listino.id}>
                              {listino.name}
                            </Option>
                          ))}
                    </Select>
                  </div>
                </div>
                {screenWidth > 600 && (
                  <Popover
                    placement="bottom"
                    content={
                      <div
                        style={{ display: "flex", flexDirection: "column", gap: 5 }}
                      >
                        {Object.keys(visibleColumns).map((colKey) => (
                          <div
                            key={colKey}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 5,
                            }}
                          >
                            {typeof visibleColumns[colKey] === "object" ? (
                              <>
                                {colKey === "Images" || colKey === "Proviggione" ? (
                                  <Checkbox
                                    checked={Object.values(
                                      visibleColumns[colKey],
                                    ).every(Boolean)}
                                    onChange={() => handleCheckAll(colKey)}
                                  >
                                    {colKey === "Proviggione" ? "Utili" : "Media"}
                                  </Checkbox>
                                ) : null}

                                {Object.keys(visibleColumns[colKey]).map(
                                  (subKey) => (
                                    <Checkbox
                                      key={subKey}
                                      checked={visibleColumns[colKey][subKey]}
                                      onChange={(e) =>
                                        handleCheckboxChange(e, colKey, subKey)
                                      }
                                      style={{ marginLeft: 16 }}
                                    >
                                      {subKey}
                                    </Checkbox>
                                  ),
                                )}
                              </>
                            ) : (
                              <Checkbox
                                checked={visibleColumns[colKey]}
                                onChange={(e) => handleCheckboxChange(e, colKey)}
                              >
                                {colKey}
                              </Checkbox>
                            )}
                          </div>
                        ))}
                      </div>
                    }
                    trigger="click"
                  >
                    <Button style={{ height: 37, marginRight: 5 }}>
                      Opzioni Tabela
                    </Button>
                  </Popover>
                )}
              </div>
            </div>
            {/* {servicesLoader && <div className="loaderAdmin"></div>} */}

            {
              <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record.id}
                scroll={{ y: "calc(100vh - 240px)" }}
                onChange={async (pagination, filters, sorter) => {
                  const newActiveFilter = filters.serviceActive
                    ? filters.serviceActive[0]
                    : null

                  // SORT
                  if (sorter?.columnKey === "full_name") {
                    const sortOrder = sorter.order === "ascend" ? "asc" : "desc"
                    setSort(sortOrder)

                    await getAllServices(
                      activeSkinId,
                      selectedSupplier !== "TUTTI" ? selectedSupplier : null,
                      selectedListino,
                      currentPage,
                      perPage,
                      filterName,
                      activeCategory,
                      sortOrder,
                      filter,
                    )
                    return
                  }

                  // FILTER (only if changed)
                  if (newActiveFilter !== filter) {
                    setFilter(newActiveFilter)

                    await getAllServices(
                      activeSkinId,
                      selectedSupplier !== "TUTTI" ? selectedSupplier : null,
                      selectedListino,
                      currentPage,
                      perPage,
                      filterName,
                      activeCategory,
                      sort,
                      newActiveFilter,
                    )
                  }
                }}
              />
            }
            {
              <div className="paginationWrapper">
                <Pagination
                  current={currentPage}
                  onChange={(e) => {
                    setCurrentPage(e)
                    getAllServices(
                      activeSkinId,
                      selectedSupplier !== "TUTTI" ? selectedSupplier : null,
                      selectedListino,
                      e,
                      perPage,
                      filterName,
                      activeCategory,
                      sort,
                      filter,
                    )
                  }}
                  total={
                    allServices?.data?.length === 0 ? 1 : allServices.last_page * 10
                  }
                />
                <Select
                  defaultValue={25}
                  onChange={(e) => {
                    setPerPage(e)
                    getAllServices(
                      activeSkinId,
                      selectedSupplier !== "TUTTI" ? selectedSupplier : null,
                      selectedListino,
                      1,
                      e,
                      filterName,
                      activeCategory,
                      sort,
                      filter,
                    )
                  }}
                >
                  <Option value={10}>10 / Pagina</Option>
                  <Option value={25}>25 / Pagina</Option>
                  <Option value={50}>50 / Pagina</Option>
                  <Option value={100}>100 / Pagina</Option>
                </Select>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  screenWidth: state.main.screenWidth,
  activeSkinId: state.main.activeSkinId,
  allServices: state.auth.allServices,
  servicesLoader: state.auth.servicesLoader,
  skinList: state.auth.skinList,
  providers: state.main.providers,
  accountInfo: state.auth.accountInfo,
  servicesTree: state.main.servicesTree,
  listinoList: state.main.listinoList,
  contiGiocoServices: state.auth.contiGiocoServices,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  withRouter(NewServicesAdmin),
)
